const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  role: localStorage.getItem("role") || null,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setRole: (state, action) => {
      state.role = action.payload;
    },
    clearRole: (state) => {
      state.role = null;
    },
  },
});

export const { setRole, clearRole } = roleSlice.actions;
export const selectRole = (state) => state.role.role;

export default roleSlice.reducer;
